module.exports = __webpack_public_path__ + "static/img/アセット 32@2x.7e55f79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 32@2x.png
// module id = s4ql
// module chunks = 1